/**
 * WebGazer must not be Vite-bundled: MediaPipe Face Mesh loads sibling
 * wasm/js via locateFile relative to the page. Those files must be served
 * from our origin at /mediapipe/face_mesh (copied from the npm package).
 */

/** Keep in sync with package.json "webgazer" and the copy-assets script. */
export const WEBGAZER_NPM_VERSION = '3.5.3';

export function webGazerScriptUrl(): string {
  return `https://cdn.jsdelivr.net/npm/webgazer@${WEBGAZER_NPM_VERSION}/dist/webgazer.js`;
}

/**
 * Absolute site path WebGazer 3 uses for Face Mesh solution files
 * (face_mesh_solution_*.js/wasm, face_mesh.binarypb, …).
 */
export function webGazerFaceMeshAssetBase(): string {
  return '/mediapipe/face_mesh';
}
